export const firebaseConfig = {
  apiKey: "AIzaSyAvn-pwIbDGPMrP73lmCbVqzS4Dh6JZJ_I",
  authDomain: "nerd-forum.firebaseapp.com",
  projectId: "nerd-forum",
  storageBucket: "nerd-forum.appspot.com",
  messagingSenderId: "563472919029",
  appId: "1:563472919029:web:f3bd008f661bf8669758bc",
  measurementId: "G-VMZG3RY5MX",
};
